import { Progress } from 'antd';
import styled from 'styled-components';

export default styled(Progress)`
	// Add your styles here
`;
